//Librairies
import React from 'react';
import styled from "styled-components";

//Composants
import Cv from "../components/Cv";
import {TitleSection} from "../styles/globalStyles";

//Images
import cvPdf from "../assets/images/CV_Vasco.pdf";
import imagePortrait from "../assets/images/image-portrait.png";


const About = () => {
    return (
        <Section id="about">
            <TitleSection>A PROPOS</TitleSection>
            <div className="container-me">
                <div className="text">
                    <p>👋 Hey ! </p>
                    <p> Je suis développeur fullstack autodidacte, travaillant principalement avec du <span> JavaScript</span> utilisant des technologies modernes comme <span> React</span> et <span>TypeScript</span>.</p>
                    <p> Ayant soif d'apprendre et étant passionné pour le développement web, je réalise régulièrement des projets et de la veille technologique.
                    </p>
                </div>

            </div>
            <a className='cv_mobil' href={cvPdf} download="cv-vasco_barreiros.pdf">
            <p>Télécharger mon CV</p>
            </a>
            <Cv/>
        </Section>
    );
};

const Section = styled.section`
  width: 100%;
  min-height: 100vh;
  display: flex;
  gap:54px;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  //justify-content: j;
   

  span {
    background: rgba(173, 168, 165, 0.42);
    /* padding: 0 10px; */
    border-radius: 4px;
  }

  a{
    color:inherit;
    text-decoration: none;
  }

  .cv_mobil > p{
    border:1px solid black;
    padding:20px 16px;
    border-radius: 4px;
    display: none;
    visibility: hidden;
    margin-bottom: 100px;
    @media(max-width: 1024px){
      display: block;
      visibility: visible;
  }
  }


  .container-me {
    display: flex;
    align-items: center;
    //flex-direction: column;
    position: relative;
    width: 70%;
  }

  .image-portrait{
    margin-right: 5%;
    border-radius: 50%;
    //filter: saturate(0);
  }
  
  .skills{
    display: flex;
    flex-direction: row;
  }

  .text  {
    width: min(100% - 2rem, 600);
    letter-spacing: 1px;
    
  }

  .text > p {
    font-weight: 300;
  }

  h4, p {
    font-size: 22px;
    font-family: 'Poppins', sans-serif;
    
    @media (max-width:48em) {
        font-size:${props => props.theme.fontmd};
    }
    @media (max-width:30em) {
        font-size:${props => props.theme.fontsm};
    }
  }
  
  
  @media(min-width: 1060px){
    .container-me{
      bottom:100px;
    }
  }
  @media(max-width: 768px){
    .container-me{
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .text{
      font-size: 14px;
    }
  }
`

export default About;